import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef } from "vue";
import { ref, watch } from 'vue';
import { useVModel } from '@vueuse/core';
import { addUserApproval, getUserManageList, updateUserApproval } from '@/api/user';
import { ElMessage } from 'element-plus';
import { TYPE_OPTIONS, rules } from '../config';
export default {
  __name: 'add',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object
    }
  },
  emits: ['update:modelValue', 'getData', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    watch(() => props.model, val => {
      if (val) {
        form.value = {
          ...val,
          value: {
            id: val.auditorId,
            label: val.auditorName,
            ...val
          }
        };
      }
    });
    const emits = __emit;
    const dialogVisible = useVModel(props);
    const formRef = ref(null);
    const form = ref({
      value: '',
      level: '',
      type: 1
    });
    const loading = ref(false);
    const options = ref([]);
    const remoteMethod = async query => {
      if (query) {
        loading.value = true;
        const res = await getUserManageList({
          keyword: query
        });
        options.value = res.records.map(item => ({
          id: item.id,
          label: item.name || item.username
        }));
        loading.value = false;
      } else {
        options.value = [];
      }
    };
    const resetForm = () => {
      formRef.value.resetFields();
      emits('clearModel');
      form.value = {
        value: '',
        level: '',
        type: 1
      };
    };
    const submitForm = () => {
      if (!formRef.value) return;
      formRef.value.validate(async valid => {
        if (!valid) return;
        if (!props.model) {
          var _form$value$value, _form$value$value2;
          await addUserApproval({
            auditorId: (_form$value$value = form.value.value) === null || _form$value$value === void 0 ? void 0 : _form$value$value.id,
            auditorName: (_form$value$value2 = form.value.value) === null || _form$value$value2 === void 0 ? void 0 : _form$value$value2.label,
            level: form.value.level,
            type: form.value.type
          });
        } else {
          var _form$value$value3, _form$value$value4;
          await updateUserApproval({
            ...props.model,
            auditorId: (_form$value$value3 = form.value.value) === null || _form$value$value3 === void 0 ? void 0 : _form$value$value3.id,
            auditorName: (_form$value$value4 = form.value.value) === null || _form$value$value4 === void 0 ? void 0 : _form$value$value4.label,
            level: form.value.level,
            type: form.value.type
          });
        }
        emits('clearModel');
        emits('getData');
        ElMessage({
          type: 'success',
          message: `${props.model ? '修改' : '添加'}成功`
        });
        dialogVisible.value = false;
        resetForm();
      });
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        class: "dialog-class",
        title: (__props.model ? '修改' : '新增') + '审批人',
        onClosed: resetForm,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          rules: _unref(rules),
          "label-width": "150px",
          "status-icon": "",
          model: form.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "审批人",
            prop: "value",
            rules: _unref(rules).value
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.value.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.value = $event),
              "value-key": "id",
              filterable: "",
              remote: "",
              placeholder: "请输入用户关键字",
              "remote-method": remoteMethod,
              loading: loading.value,
              style: {
                "width": "240px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.label,
                  value: item
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "loading"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_el_form_item, {
            prop: "level",
            label: "审批顺序节点",
            rules: _unref(rules).level
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.level,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.level = $event),
              type: "number"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_el_form_item, {
            prop: "type",
            label: "审批的事项类型"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: form.value.type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.type = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TYPE_OPTIONS), (item, index) => {
                return _openBlock(), _createBlock(_component_el_radio, {
                  label: item.value,
                  size: "large",
                  border: "",
                  key: index
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                  _: 2
                }, 1032, ["label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["rules", "model"])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
};